module.exports = {"540329100":"孜托镇","540329101":"硕督镇","540329102":"康沙镇","540329103":"马利镇","540329200":"玉西乡","540329201":"新荣乡","540329202":"达龙乡","540329203":"腊久乡","540329204":"俄西乡","540329205":"中亦乡","540329206":"白达乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540329.json
// module id = 2518
// module chunks = 0